import styled, { keyframes } from 'styled-components';
import { LayoutProps, layout } from 'styled-system';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledLoading = styled.div<
  LayoutProps & {
    type?: 'primaryGreen' | 'green' | 'blue';
  }
>`
  border: 3px solid #f3f3f3;
  border-top: 3px solid;
  border-top-color: ${({ theme, type }): string =>
    !type
      ? theme.colors.primaryBlue
      : type === 'green'
      ? theme.colors.secondaryGreen
      : type === 'blue'
      ? theme.colors.primaryBlue
      : theme.colors.primaryGreen};
  border-radius: 55%;
  animation: ${rotate} 1s linear infinite;
  ${layout}
`;
